import { useEffect } from "react";

import { useSetRecoilState } from "recoil";
import {
  getDoc,
  setDoc,
  DocumentReference,
  serverTimestamp,
  DocumentData,
} from "firebase/firestore";
import { getAuth, User } from "firebase/auth";
import { getRef } from "lib/firebase";
import { userState } from "pages/_app";

import { CurrentUser } from "lib/type";

const createUser = async (
  userDocRef: DocumentReference<DocumentData>,
  firebaseUser: User
) => {
  await setDoc(userDocRef, {
    uid: firebaseUser.uid,
    name: firebaseUser.displayName,
    avatar: firebaseUser.photoURL,
    color: "#ffffff",
    isSendNotif: true,
    email: firebaseUser.email,
    bio: "",
    links: [],
    totalLikeCount: 0,
    followerCount: 0,
    createdAt: serverTimestamp(),
  });
  const userDoc = await getDoc(userDocRef).catch((err) => {
    console.log(err);
    return null;
  });
  return userDoc || null;
};

export const useAuth = () => {
  const setUser = useSetRecoilState(userState);

  useEffect(() => {
    getAuth().onAuthStateChanged(async (firebaseUser) => {
      if (!firebaseUser) return setUser(null);

      const userDocRef = getRef("users", firebaseUser.uid);
      let userDoc = await getDoc(userDocRef).catch((err) => {
        console.log(err);
        return null;
      });
      if (userDoc && !userDoc.exists())
        userDoc = await createUser(userDocRef, firebaseUser);
      if (!userDoc) return setUser(null);

      const userData = userDoc.data();
      if (!userData) return setUser(null);
      const {
        uid,
        name,
        avatar,
        color,
        isSendNotif,
        email,
        bio,
        links,
        totalLikeCount,
        followerCount,
      } = userData;
      const signInUser: CurrentUser = {
        uid: uid,
        name: name,
        avatar: avatar,
        color: color,
        isSendNotif: isSendNotif,
        email: email,
        bio: bio,
        links: links,
        totalLikeCount: totalLikeCount,
        followerCount: followerCount,
      };
      setUser(signInUser);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
